import React from 'react';
import getConfig from 'next/config';

import styles from './PostCategory.module.scss';
import { parseCategories } from '../../utils/parseCategories';
import { ICategoriesNodes } from '../../lib/types';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

interface PostCategoryProps {
  categories: ICategoriesNodes;
}

const PostCategory = (props: PostCategoryProps) => {
  const { categories } = props;
  return (
    <div className={styles['post-category']}>
      {categories && categories.nodes ? (
        categories.nodes.map((category, i) => {
          return (
            <div key={category.slug}>
              <a
                href={`${BASE_URL_MEDIA}category${parseCategories.getCleanURI(category)}`}
                className={'post-category__item'}
                title={category.name}
              >
                {category.name}
              </a>
              {categories.nodes.length - 1 !== i && <span> / </span>}
            </div>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};

export default PostCategory;
